import { AuthProtectedRoute } from "common/components/AuthProtectedRoute";
import {
  ProtectionType,
  UserInfoProtectedRoute,
} from "components/UserInfoProtectedRoute";
import { BrowseSales, Dashboard, Sale } from "pages";
import { AuthenticationRouter } from "pages/authentication/Router";
import { Congratulations } from "pages/congratulations/Congratulations";
import { IDNowStatus } from "pages/idnow-status/IDNowStatus";
import { InvestmentFlow } from "pages/investment/InvestmentFlow";
import { KnowYourCustomerForm } from "pages/kyc/KnowYourCustomerForm";
import { Documents } from "pages/user/Documents";
import { PersonalData } from "pages/user/PersonalData";
import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

export const AppRouter = () =>
  <Router>
    <Switch>
      <Route path="/authentication">
        <AuthenticationRouter />
      </Route>
      <UserInfoProtectedRoute
        path="/shares/:id"
        component={InvestmentFlow}
        reverseLogic={false}
        protection={ProtectionType.UserVerified}
      />
      <AuthProtectedRoute path="/congratulations" component={Congratulations} />
      <AuthProtectedRoute path="/dashboard" component={Dashboard} />
      <UserInfoProtectedRoute
        path="/personal-data"
        component={PersonalData}
        reverseLogic={false}
      />
      <AuthProtectedRoute path="/documents" component={Documents} />
      <AuthProtectedRoute path="/kyc" component={KnowYourCustomerForm} />
      <AuthProtectedRoute path="/offerings" component={BrowseSales} />
      <AuthProtectedRoute path="/offering/:id/:assetType" component={Sale} />
      <AuthProtectedRoute path="/idnowstatus" component={IDNowStatus} />
      <Route path="/">
        <AuthenticationRouter />
      </Route>
    </Switch>
  </Router>
;
